import React, { useContext, useEffect, useState } from 'react';
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { ThemeContext } from '../../context/theme.context';
import BusinessLogiConfiguration from './BusinessLogiConfiguration';
import SourceAdaptor from './SourceAdaptor';
import SyncContainer from './SyncContainer';
import TaskManager from './TaskManager';
import TaskTracker from './TaskTracker';

const DigTabHub: React.FC = () => {
  const context = useContext(ThemeContext);
  const [currentTab, setCurrentTab] = useState(0);
  useEffect(() => {
    if (context.isChangeCurrentTab) {
      setCurrentTab(1);
      context.setChangeCurrentTab(
        false,
        context.changeCurrentContainerTabIndex
      );
    }
    if (context.isChangeCurrentTabTask) {
      setCurrentTab(2);
      context.setChangeCurrentTabTask(false, context.currentTabTaskIndex);
    }
  }, [context]);
  return (
    <div>
      <TabComponent
        heightAdjustMode='Auto'
        selected={(args: any) => {
          setCurrentTab(args.selectingIndex);
        }}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={{
              text: 'Source Adapter',
            }}
            content={() => <SourceAdaptor />}
          />
          <TabItemDirective
            header={{
              text: 'Sync Container',
            }}
            content={() => <SyncContainer />}
          />
          <TabItemDirective
            header={{
              text: 'Task Manager',
            }}
            content={() => <TaskManager />}
          />
          <TabItemDirective
            header={{
              text: 'Business Logic Configuration',
            }}
            content={() => <BusinessLogiConfiguration />}
          />
          <TabItemDirective
            header={{
              text: 'Task Tracker',
            }}
            content={() => <TaskTracker />}
          />
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
};

export default DigTabHub;
